module.exports = __webpack_public_path__ + "4a24e3962c825f7e486fb69557496c92.svg";